import {useState} from 'react'
import { NavLink } from "react-router-dom";
// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import PieActiveArc from "components/PieChart/PieChart"

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Card from "@mui/material/Card"

import { useMaterialUIController, setLayout } from "context";
import MDTypography from "components/MDTypography";

/* eslint-disable react/prop-types */



export default function PersonalDataCharts({title, data}) {

    return (
        <>
        <MDTypography variant="h6" fontWeight="bold" gutterBottom style={{marginTop:"1rem"}} >
          {title}
        </MDTypography>
        <MDBox display="flex" justifyContent="space-between">
          {"Gender" in data &&
          <MDBox width={150} justifyContent="center" alignItems="center">
            <MDTypography variant="h6" fontWeight="regular" gutterBottom style={{textAlign:"center"}}>
              {"Gender"}
            </MDTypography>
            <PieActiveArc onClickId={() => {}} data={data['Gender'] } legendHidden={true}/>
          </MDBox>
          }
          {"Age" in data && 
          <MDBox width={150} justifyContent="center">
            <MDTypography variant="h6" fontWeight="regular" gutterBottom style={{textAlign:"center"}}>
              {"Age"}
            </MDTypography>
            <PieActiveArc onClickId={() => {}} data={data['Age']} legendHidden={true}/>
          </MDBox>
          }
          <MDBox width={150} justifyContent="center">
            <MDTypography variant="h6" fontWeight="regular" gutterBottom style={{textAlign:"center"}}>
              {"City"}
            </MDTypography>
            <PieActiveArc onClickId={() => {}} data={data['City']} legendHidden={true}/>
          </MDBox>
          <MDBox width={150} justifyContent="center">
            <MDTypography variant="h6" fontWeight="regular" gutterBottom style={{textAlign:"center"}}>
              {"Yearly income"}
            </MDTypography>
            <PieActiveArc onClickId={() => {}} data={data['Yearly income']} legendHidden={true}/>
          </MDBox>
        </MDBox>
        <MDBox display="flex" justifyContent="space-between">
          <MDBox width={150} justifyContent="center">
            <MDTypography variant="h6" fontWeight="regular" gutterBottom style={{textAlign:"center"}}>
              {"Main interests"}
            </MDTypography>
            <PieActiveArc onClickId={() => {}} data={data['Main interests']} legendHidden={true}/>
          </MDBox>
          <MDBox width={150} justifyContent="center">
            <MDTypography variant="h6" fontWeight="regular" gutterBottom style={{textAlign:"center"}}>
              {"Average expenditure"}
            </MDTypography>
            <PieActiveArc onClickId={() => {}} data={data['Average expenditure']} legendHidden={true}/>
          </MDBox>
          <MDBox width={150} justifyContent="center">
            <MDTypography variant="h6" fontWeight="regular" gutterBottom style={{textAlign:"center"}}>
              {"Preferred amenitis"}
            </MDTypography>
            <PieActiveArc onClickId={() => {}} data={data['Preferred amenitis']} legendHidden={true}/>
          </MDBox>
        </MDBox>
      </>

    );


}